{
  "id": "poseidon",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Poseidon",
    "en": "Poseidon"
  },
  "icon": "gods/poseidon",
  "portrait": "gods/poseidon-portrait",
  "modifiers": [
    {
      "target": "cost",
      "op": "mul",
      "value": 0.7,
      "scope": {
        "ids": ["stable", "market"],
        "resources": ["wood"]
      },
      "note": "Stable and Market wood cost x0.70 Percent (both cost only wood)."
    }
  ],
  "powers": ["lure"],
  "minors": {
    "classical": ["hermes", "ares"],
    "heroic": ["dionysus", "aphrodite"],
    "mythic": ["artemis", "hephaestus"]
  },
  "unlocks": [
    "hetairos",
    "militia",
    "hippocampus",
    "theseus",
    "atalanta",
    "hippolyta",
    "polyphemus",
    "lord-of-horses"
  ],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Also (not modelled): Militia partisans from razed buildings; myth units, cavalry and caravans +0.1 speed per age; market buy factor -0.10 / sell factor +0.10; respawning Hippocampus at a Dock."
  }
}
